<template>
    <v-app>

        <div @mousemove="mouseMove" style="height:100%;">

            <flash-message></flash-message>

            <div v-if="authenticated">

                <app-toolbar @drawer:cycle="cycleDrawerMenu"
                             :translations="translations"
                ></app-toolbar>

                <app-navigation-drawer v-model="drawerModel"
                                       :translations="translations"
                ></app-navigation-drawer>
            </div>

            <enable-notifications-dialog v-if="showNotificationDialog"
                                         :action-button-color="config.settings.actionButtonColor"
                                         :translations="translations"
                                         :panelist-id="account.id"
            ></enable-notifications-dialog>

            <!-- Router view rendered here -->
            <v-main class="member_app_main" style="background-color: #F5F5F5;height:100%;">
                <keep-alive>
                    <router-view></router-view>
                </keep-alive>
            </v-main>

        </div>
    </v-app>
</template>

<script>

import {mapActions, mapMutations, mapState} from 'vuex';
import FlashMessage from "@/components/application/FlashMessage.vue";
import Store from "@/modules/MemberApp/store/index.ts";
import AppNavigationDrawer from "@/modules/MemberApp/components/AppNavigationDrawer.vue";
import AppToolbar from "@/modules/MemberApp/components/AppToolbar.vue";
import {bootstrap, setOptions} from "vue-gtag";
import EnableNotificationsDialog from "@/components/UI/Dialogs/EnableNotificationsDialog.vue";
import Api from "@/api.js";

const vuexModule = 'Community';
const USER_IDLE_SECONDS = 60 * 15;

export default {

    components: {
        EnableNotificationsDialog,
        AppToolbar,
        AppNavigationDrawer,
        FlashMessage,
    },

    data() {
        return {
            drawerModel: false,
            sessionExpiredModel: false,
            messagingDebug: true,
            notificationsToken: null,
            lastMouseMoveTimeout: null,
            userIdle: false,
        }
    },

    computed: {

        ...mapState(vuexModule, [
            'oauth',
            'config',
            'account',
            'authenticated',
            'availableProjects',
            'availableQuestions'
        ]),

        translations() {
            return this.config.translations;
        },

        showNotificationDialog() {
            return this.authenticated && this.account && this.account.enable_push_notifications;
        }
    },

    watch: {
        $route(to, from) {

            // if (this.config.ga_enabled) {
            //     this.$gtag.pageview({
            //         page_path: this.$route.path,
            //         page_title: this.config.sub_panel_name + ' (' + this.config.locale.code + ')'
            //     })
            // }
        }
    },

    methods: {

        ...mapActions(vuexModule, [
            'getAccountDetails',
            'getAvailableProjects',
            'getQuestions',
            'updateNotificationToken',
            'deleteNotificationToken'
        ]),

        ...mapMutations(vuexModule, [
            'setOAuthData',
            'setConfig',
            'setBuild'
        ]),

        cycleDrawerMenu() {
            this.drawerModel = !this.drawerModel;
        },

        enableGoogleAnalytics() {

            // if (this.config.ga_enabled) {
            //
            //     setOptions({
            //         config: {id: this.config.ga_ua}
            //     })
            //
            //     bootstrap().then(() => {
            //         this.$gtag.pageview({
            //             page_path: this.$route.path,
            //             page_title: this.config.sub_panel_name + ' (' + this.config.locale.code + ')'
            //         })
            //     })
            // }
        },

        addUnauthenticatedInterceptor() {

            axios.interceptors.response.use(function (response) {
                return response
            }, function (error) {

                if (!error.response) {
                    console.error(error);
                }

                if (error.response && error.response.status === 401) {
                    window.location.replace('/app/logout');
                }

                return Promise.reject(error)
            })
        },

        mouseMove() {

            if (this.lastMouseMoveTimeout) {
                clearTimeout(this.lastMouseMoveTimeout)
            }

            if (this.userIdle) {
                this.setUserActive();
            }

            this.lastMouseMoveTimeout = setTimeout(() => {
                this.setUserIdle();
            }, 1000 * USER_IDLE_SECONDS)
        },

        setUserActive() {
            console.log("User active");
            Bus.$emit('user-active');
            this.reloadNewVersion();
            this.userIdle = false;
        },

        setUserIdle() {
            console.log("User idle");
            Bus.$emit('user-idle');
            this.reloadNewVersion();
            this.userIdle = true;
        },

        reloadNewVersion() {
            Api.get('/app-build')
                .then(({data}) => {
                    if (data.build !== this.$store.state.build) {
                        window.location.reload();
                    }
                });
        }
    },

    mounted() {

        if (this.authenticated) {

            this.drawerModel = true;

            this.getAccountDetails()
                .catch((error) => {
                    console.error(error);
                    Bus.$emit('flash-message', {type: 'error', message: this.translations.application_error});
                });

            if (this.config.dynamic_profiling_enabled) {

                this.getQuestions()
                    .then(() => {
                        if (this.availableQuestions) {
                            Bus.$emit('available-questions', this.availableQuestions.length)
                        }
                    })
                    .catch(error => {

                        if (error.response && error.response.status === 409) {
                            return;
                        }

                        console.error("MemberApp/index getQuestions() error: ".error);

                        Bus.$emit('flash-message', {
                            type: 'error',
                            message: this.translations.dynamic_profiling_error_text
                        });
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }

        this.enableGoogleAnalytics();
    },

    created() {

        this.addUnauthenticatedInterceptor();

        const loader = document.getElementById('ninja-loader');

        if (loader) {
            loader.remove();
        }

        if (!this.$store.state[vuexModule]) {
            this.$store.registerModule(vuexModule, Store);
        }

        if (Spark.oauth) {
            this.setOAuthData(Spark.oauth);
            this.drawerModel = true;
        }

        this.setConfig(Spark.config);
        this.setBuild(Spark.app.build);

        Bus.$on('session-expired', () => {
            this.sendToUrl(this.config.login_url);
        });

        Bus.$on('account:reload', () => {
            this.getAccountDetails(true);
        });
    }
}

</script>
